<div kui-action class="d-flex flex-1" [ngClass]="classNames" (click)="primaryActionClicked.emit()">
    <key-feed-entry-info>
        <span id="info-title">
            <span kui-tooltip="{{data?.dateStart | date: 'yyyy-MM-dd HH:mm:ss'}}"
                [showOnTouchscreen]="true"
                align="left">{{ data?.dateStart | units: { unit: 'time', variant: 'short' } }}</span>
                - <span kui-tooltip="{{data?.dateEnd | date: 'yyyy-MM-dd HH:mm:ss'}}"
                    [showOnTouchscreen]="true">{{ data?.dateEnd | units: { unit: 'time', variant: 'short' } }}</span>
        </span>
        <span id="info-small-text" class="small muted d-flex flex-column">
            <span>{{ tripTime | formatSeconds }}</span>
            @if (distance) { <span>{{ distance }}</span> }
        </span>
        <div id="info-custom-icons" class="rating" [kui-tooltip]="data.ratingScore ? ('SHARED.TOOLTIP.DRIVER_RATING' | translate: { score: data.ratingScore }) : null">
            @if (data.ratingScore) {
                <kui-icon name="circle"
                    [size]="'xs'"
                    [fill]="true"
                    [ngStyle]="{ color: data.ratingScore | ratingColour }">
                </kui-icon>
                <span class="muted-less small">{{data.ratingScore}}</span>
            }
        </div>
    </key-feed-entry-info>

    <div class="feed-entry-details">
        @if (data?.locationStart && data?.locationEnd) {
            <!-- <div id="entry-title"
  [innerHTML]="title"></div> -->
            @if (active) {
                <div id="entry-title" class="d-flex entry-title">
                    <div class="accent d-flex flex-row">
                        <kui-icon name="flag" class="pr-2 icon-trip icon-trip-start"></kui-icon>
                        <span>{{ titleStart }}</span>
                    </div>
                    <div class="px-2">
                        <kui-icon name="arrow-right-long" class="icon-trip-arrow"></kui-icon>
                    </div>
                    <div class="accent d-flex flex-row">
                        <kui-icon name="flag-checkered" class="pr-2 icon-trip icon-trip-end"></kui-icon>
                        <span>{{ titleEnd }}</span>
                    </div>
                </div>
            }
            @if (!active) {
                <div id="entry-title" class="d-flex entry-title">
                    <div class="accent d-flex flex-row">
                        <kui-icon name="power-off" class="pr-2 icon-trip icon-trip-parked"></kui-icon>
                        <span>{{ titleStart }}</span>
                    </div>
                </div>
            }
            <div id="entry-description">
                @for (linkedAsset of linkedAssets; track linkedAsset) {
                    <div>
                        <kui-icon [name]="linkedAsset.icon" class="mr-1"></kui-icon>
                        {{ linkedAsset.name }}
                    </div>
                }
                <div class="muted-less" [innerHTML]="description"></div>
                @if (labels && labels.length) {
                    <div class="mt-1">
                        <key-label-badges [labels]="labels"></key-label-badges>
                    </div>
                }
            </div>
        } @else {
            <div id="entry-title" class="accent">
                {{ "SHARED.FEED_ENTRY.TRIP.UNKNOWN.TITLE" | translate }}
            </div>
            <div id="entry-description">
                @for (linkedAsset of linkedAssets; track linkedAsset) {
                    <div>
                        <kui-icon [name]="linkedAsset.icon" class="mr-1"></kui-icon>
                        {{ linkedAsset.name }}
                    </div>
                }
                <div class="muted-less">
                    {{ "SHARED.FEED_ENTRY.TRIP.UNKNOWN.DESCRIPTION" | translate }}
                </div>
            </div>
        }
    </div>
</div>

@if (actions && actions.length) {
    <key-feed-entry-actions [actions]="actions"></key-feed-entry-actions>
}
